// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    /**
     * 提交用户输入的登录信息
     */
    executelogin() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/Login/executelogin',
        data: { username: this.username, password: this.password },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          if (response.data.code == 1) {
            // 先存localStorage，再提示操作成功，然后跳路由
            // JSON.stringify:将对象转成字符串
            // JSON.parse():将字符串装换成对象
            /* let userinfo = JSON.stringify(response.data.userinfo);//将当前信息变成json字符串
            localStorage.userinfo = userinfo;//存储用户信息
            let nowtime = new Date().getTime();
            localStorage.logintime = nowtime;// */
            // alert("登陆成功");
            self.$Message.success('登陆成功');
            self.$router.push({
              path: '/', // 这是路由名称
            });
          } else {
            alert('用户名或密码错误');
          }
        })
        .catch((response) => {
          // alert("请求失败");
        });
    },
  },
};
